import React from 'react';
import LegacyButton from '@src/js/Components/Base/Button';
import replaceCssClasses from '@src/js/Style';
import AbstractComponent from './AbstractComponent';
import SkeletonText from '../Skeleton/SkeletonText';

export default class Button extends AbstractComponent {

    getContent() {

        const value = this.getValue();

        return value
            ? <LegacyButton { ...this.getProps() }>{ value }</LegacyButton>
            : super.getContent();
    }

    getSkeleton() {

        return <SkeletonText height='50px' skeletonClassName={ replaceCssClasses('h-full') } />;
    }

}